import React, { useEffect, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { profileValidationFields, focusProfileField } from './profileValidationFields'

export default function ProfileEditError({ command, reload }) {
  const [confirmReload, setConfirmReload] = useState(false)
  const [fields, setFields] = useState([])
  useEffect(() => {
    const rejected = profileValidationFields(command.code)
    setFields(rejected)
    if (rejected.length) focusProfileField(rejected[0].id)
  }, [command.code])
  if (!command.message) return null
  return <>
    <div className="alert alert-danger" role="alert">{fields.length ? <>Check the following details before saving:
      <ul className="mb-0">{fields.map(field => <li key={field.id}><button type="button" className="btn btn-link p-0 text-left"
        onClick={() => focusProfileField(field.id)}>Check {field.label}</button></li>)}</ul></> : command.message}
      {command.code === 'PROFILE_REVISION_CONFLICT' && <button type="button" className="btn btn-link" onClick={() => setConfirmReload(true)}>Reload current details</button>}
    </div>
    <Modal isOpen={confirmReload} toggle={() => setConfirmReload(false)}>
      <ModalHeader toggle={() => setConfirmReload(false)}>Discard local changes?</ModalHeader>
      <ModalBody>Reloading replaces the details in this form with the current saved profile. Your local changes will be discarded.</ModalBody>
      <ModalFooter><button type="button" className="btn btn-light" onClick={() => setConfirmReload(false)}>Keep editing</button>
        <button type="button" className="btn btn-primary" onClick={reload}>Discard and reload</button></ModalFooter>
    </Modal>
  </>
}
